import Payment from "./Payment";
import Biller from "./Biller";
import Account from "./Account";
import Bill from "./Bill";
import AddBiller from "./AddBiller";
import Autopay from "./Autopay";
import Profile from "./Profile";
import Reminder from "./Reminder";
import PaymentInquiry from "./PaymentInquiry";
import Email from "./Email";
import BillerGroup from "./BillerGroup";
import { useEffect,useState } from "react";
export default {Payment,Biller,Bill,Account, AddBiller, Autopay, Profile, Reminder, PaymentInquiry, Email, BillerGroup}
export {Payment,Biller,Bill,Account, AddBiller, Autopay, Profile, Reminder, PaymentInquiry, Email, BillerGroup};
export function ShowOnMobile(props) {
   const maxWidth = 899;
    const [isMobile, setIsMobile] = useState(
      typeof window !== "undefined" ? window.innerWidth < maxWidth : false
    );
  
    useEffect(() => {
      function handleResize() {
        setIsMobile(window.innerWidth < maxWidth);
      }
  
      handleResize(); // run on mount
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, [maxWidth]);
  
    return  isMobile && props.children
        
  }
  export function ShowOnDesktop(props) {
    const minWidth = 900;
    const [isDesktop, setIsDesktop] = useState(
      typeof window !== "undefined" ? window.innerWidth > minWidth : false
    );
  
    useEffect(() => {
      function handleResize() {
        setIsDesktop(window.innerWidth > minWidth);
      }
  
      handleResize(); // run on mount
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, [minWidth]);
  
    return  isDesktop && props.children
        
  }